import script from "./ElectrolitView.vue?vue&type=script&setup=true&lang=js"
export * from "./ElectrolitView.vue?vue&type=script&setup=true&lang=js"

import "./ElectrolitView.vue?vue&type=style&index=0&id=c0ac0c38&lang=css"

const __exports__ = script;

export default __exports__